import { cn } from '@/service/utils/cn';
import { Overlay } from '../../Overlay/Overlay';
import { FormButton } from '../../Buttons/FormButton';
import { IconButton } from '../../Buttons/IconButton';
import { CloseIcon } from '../../Icons/CloseIcon';

type TConfirmationPopupProps = {
    className?: string;
    confirmText?: string;
    cancelText?: string;
    isShown?: boolean;
    onHide?: () => void;
    onConfirm?: () => void;
    onCancel?: () => void;
    questionText?: string;
    infoText?: string;
};

export const ConfirmationPopup = ({
    className,
    questionText,
    infoText,
    confirmText,
    cancelText,
    isShown = false,
    onHide,
    onConfirm,
    onCancel,
}: TConfirmationPopupProps) => (
    <>
        <Overlay className="z-50 bg-black-1" isShown={isShown} onHide={onHide} />
        <div
            className={cn(
                `absolute left-1/2 top-1/2 z-50 ml-[-170px] mt-[-100px] w-full max-w-[340px] flex-col items-center rounded-[15px] bg-white pb-[18px] pt-5 shadow-popup dark:bg-dark-3 dark:shadow-popupDark md:ml-[-240px] md:max-w-[480px] ${
                    isShown ? 'flex' : 'hidden'
                }`,
                className
            )}
        >
            <IconButton
                icon={<CloseIcon className="h-9 w-9" />}
                className="absolute right-[9px] top-[11px] z-50 hidden rounded-full hover:shadow-lightCard dark:hover:shadow-dark sm:block"
                onClick={onHide}
            />
            <div className="flex w-[268px] flex-col items-center gap-2.5 sm:w-[307px]">
                <p className="tx-large-semibold text-gray-1 dark:text-white">{questionText}</p>
                <p className="tx-large-regular flex min-h-[29px] w-full items-center justify-center rounded-[50px] bg-ash-dark text-gray-2 dark:bg-blue-1 dark:text-white">
                    {infoText}
                </p>
                <div className="flex w-full items-center gap-x-2.5">
                    <FormButton
                        type="button"
                        variant="outlined"
                        size="sm"
                        className="mx-0"
                        label={confirmText}
                        onClick={onConfirm}
                    />
                    <FormButton
                        type="button"
                        size="sm"
                        className="mx-0 h-10"
                        label={cancelText}
                        onClick={onCancel}
                    />
                </div>
            </div>
            <div className="mt-[18px] h-[5px] w-[150px] rounded-[10px] bg-gradient-blue" />
        </div>
    </>
);
